import type { FaireProductEntity } from "../../entity_types/product";

export const p_t86chwkpsv: FaireProductEntity = {
  token: "p_t86chwkpsv",
  type: "product",
  name: "Coquette Ghost Halloween Women's Lounge Set - Mommy and Me",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/1f33d22c6676f04652ea20e87446866f21f463607da187a5b1bea049535e9103.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a805f0e39694e8eb629d82b7715978f3f0a2f333a52e2d22c0e0e1efd522fbbe.jpeg",
    "https://cdn.faire.com/fastly/67cbc7a57c748a435da5b5e23d910e1a9550e9b3c713b386a90e06962831610b.jpeg",
    "https://cdn.faire.com/fastly/c378828c06cc3b534ddf4eeadbffa05bd8bef3442cf55a790d76fe583ad83c6f.jpeg",
    "https://cdn.faire.com/fastly/58abd4f82019d8cbb87707d5fe070eb38e752629d7967885f76bc268f785656a.jpeg",
    "https://cdn.faire.com/fastly/8b32c5f18b1eec2d7454723b2c03c07350e8070cc0d7a9289b19dec49590f7e9.jpeg",
  ],
  priceDollars: 38,
  description:
    "From spooky movie nights to slow fall mornings, this charming lounge set brings together playful ghost prints, feminine details, and all-day comfort - perfect for twinning with your mini.\n\nFeatures:\n * Set Color: Soft Pink \n * Graphic Color: Pink and White \n * Material: 96% Polyester/4% Spandex \n * Features: Super soft; Pants have front slant pockets; Tagless inside neck label for an itch-free wear \n * Fit: Snug fit \n * Care: Machine wash cold, dry flat, not flame resistant \n\nEach lounge set is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:26.708Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
